import React from "react";
import { useTranslation } from "react-i18next";

import CheckMarkSuccessful from "../../../images/checkmark_successful.svg";
import DefaultOnboardingStatusPage from "../../ReusablePages/DefaultOnboardingStatusPage/DefaultOnboardingStatusPage";
import { ROUTES } from "../../../utils/constants";
import GameControllerIcon2 from "../../../components/icons/GameControllerIcon2";

function LoginSuccessfulPage() {
  const { t } = useTranslation("common");
  return (
    <DefaultOnboardingStatusPage
      titleText={t("onboarding.login_successful")}
      secondaryText={
        t("onboarding.you_have_successfully_logged_in_to_sigma_games") +
        t("punctuations.exclammation")
      }
      primaryImage={CheckMarkSuccessful}
      secondaryIcon={<GameControllerIcon2 />}
      redirectDelay={3000}
      redirectPath={ROUTES.ROOT.HOME}
    />
  );
}

export default LoginSuccessfulPage;
